<template>
  <div>
    <img :src="newUserAvatar" :alt="userName" class="rounded-full block h-auto w-full max-w-full" />
  </div>
</template>

<script>
import { computed } from 'vue'


export default {
  name: 'UserAvatar',
  props: {
    avatar: {
      type: String,
      default: null
    }
  },
  setup (props) {

    const newUserAvatar = computed(() => {
      return null
    })

    return {
      newUserAvatar,
      userName: computed(() => 'Example username 2')
    }
  }
}
</script>
